import { useQuery } from "@tanstack/react-query"
import { apiClient } from "@/lib/api/http"

export interface RecentSearch {
  id: string
  query: string
  createdAt: string
}

export interface Envelope<T> {
  success: boolean
  statusCode: number
  message: string
  data: T
}

export async function getRecentSearches(token: string): Promise<RecentSearch[]> {
  const { data: envelope } = await apiClient.get<Envelope<RecentSearch[]>>(
    "/search/recent",
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
  return envelope.data
}

export function useRecentSearches(token?: string | null) {
  return useQuery({
    queryKey: ["recent-searches"],
    queryFn: async () => {
      if (!token) return []
      return getRecentSearches(token)
    },
    enabled: !!token,
    staleTime: 60 * 1000,
  })
}
